module.exports = __webpack_public_path__ + "static/media/tetragrams_frequency.ccf51aad.zip";